export enum ETransportModes {
    "Inland",
    "Ocean",
    "Air",
}
